import React from "react";
import { Link } from "react-router-dom";

import AboutImg1 from "../../assets/images/Home/chiller-van-for-refrigerated-transport.webp";
import AboutImg2 from "../../assets/images/Home/freezer-truck-service-chiller-van.webp";
import AboutImg3 from "../../assets/images/Home/refrigerated-truck-service-chiller-freeze.webp";
import AboutImg4 from "../../assets/images/Home/insulated-freezer-van-interior-chill-freezer.webp";

export const homeSections = [
   // Home Hero
  {
    type: "hero",
  },
  // Home About
  {
    type: "about",

    title: "About Chiller Fleet Transport",

    image: AboutImg1,

    imageAlt: "Chiller van for refrigerated transport in Dubai UAE",

    reverse: false,

    whatsappButton: true,

    paragraphs: [
      <>We are Chiller Fleet Transport established in 2013 as a <Link to="/about-us" className="internal-link">refrigerated transport company in Dubai</Link>, focused on solving real cold chain movement challenges across the UAE. Over the past 13 years, we have grown into a fleet of 250+ vans and trucks, supporting food, dairy, meat, and pharmaceutical logistics under controlled temperature conditions.</>,

      "Operating from Ras Al Khor Industrial Area 1, we manage RTA-verified refrigerated vehicle rentals through a structured dispatch system designed around actual delivery requirements, load types, and temperature needs. Our approach is practical and operational, guaranteeing stable cold chain performance from loading to final delivery across Dubai and the wider Emirates.",
    ],
  },
  // Home Fleet
  {
    type: "fleet",
  },
  // Home About
  {
    type: "about",

    title: "Real Operation of Our Refrigerated Fleet in Dubai",

    image: AboutImg2,

    imageAlt: "Freezer truck and chiller van service operations in Dubai",

    reverse: true,

    whatsappButton: true,

    paragraphs: [
      "Chiller Fleet Transport handles refrigerated logistics across Dubai where demand can vary throughout the year. During peak periods such as summer months, Ramadan, Eid, and the winter tourism season, transport requirements increase, and fleet availability is adjusted to support both ongoing client operations and higher-volume demand without affecting scheduled deliveries.",

      "For urgent situations, a standby vehicle is maintained at the Ras Al Khor facility, allowing same-day dispatch when required. This is particularly useful for scenarios such as warehouse cooling issues or time-sensitive port clearances, where refrigerated transport needs to be arranged without delay. Smaller vehicles like chiller vans and freezer units are typically available on short notice, while larger refrigerated trucks are prepared with proper pre-cooling based on the required temperature range.",

      "For more complex requirements, selected refrigerated trucks are equipped with multi-zone temperature systems, making it possible to transport different types of cargo within a single trip under controlled conditions. In such cases, advance scheduling is often recommended to ensure vehicles are prepared before loading, helping maintain stable temperatures from start to finish.",
    ],
  },
  // Home About
  {
    type: "about",

    background: "#F8F9FA",

    title: "Transport Capabilities Supported by Our Fleet in Dubai",

    image: AboutImg3,

    imageAlt: "Refrigerated truck fleet for cold chain transport across UAE",

    reverse: false,

    paragraphs: [
      "Our vans and trucks handles multiple transport categories across Dubai through a fleet structured for temperature-controlled and general cargo movement. These capabilities reflect the primary logistics sectors we operate in across daily distribution, scheduled transport, and supply chain requirements.",
    ],

    items: [
      {
        title: "Food Delivery",
        description:
          "We support food distribution requirements across Dubai for routine supply movement.",
      },

      {
        title: "Flowers Delivery",
        description:
          "Our fleet handles transport of floral products for short-route delivery requirements.",
      },

      {
        title: "Special Events",
        description:
          "Coverage also includes logistics support for scheduled events across Dubai.",
      },

      {
        title: "Air Freight",
        description:
          "We manage ground transport linked to air freight movement between airport cargo facilities and distribution points.",
      },

      {
        title: "Rail Freight",
        description:
          "Our operations include transport solutions for rail-linked cargo.",
      },

      {
        title: "Dairy Products",
        description:
          "Supporting dairy product transport across Dubai.",
      },

      {
        title: "Poultry Products",
        description:
          "We handle logistics movement for poultry-related goods across Dubai.",
      },

      {
        title: "Goods Transport",
        description:
          "General goods transport is handled for commercial cargo movement.",
      },

      {
        title: "Meat Transport",
        description:
          "Our refrigerated fleet supports meat transport requirements across UAE.",
      },
    ],

    note:
      <>For the full info about the services we manage and provide, visit our <Link to="/services" className="internal-link">services page</Link>.</>,
  },
  // Home Service Areas
  {
    type: "service-areas",
  },
  // Home About
  {
    type: "about",

    title: "UAE East Coast Cold Chain Operations",

    paragraphs: [
      "Chiller Fleet Transport runs refrigerated transport across the UAE East Coast, connecting Dubai and Sharjah with Fujairah Port, Fujairah Free Zone, and East Coast distribution networks. Seafood processors moving landed catch to cold storage, food importers clearing containerised cargo, and distributors supplying Dibba, Masafi, and Fujairah City book through our Ras Al Khor and Sharjah dispatch.",

      "Transit runs through the Sharjah–Masafi corridor, where compressor runtime across the Hajar crossing exceeds any other inter-emirate route in the country. Units assigned to East Coast bookings are checked for sustained temperature performance before departure, and defrost cycles on frozen cargo runs are scheduled around actual transit duration.",

      "Chiller trucks, freezer trucks, and multi-temperature refrigerated trucks cover East Coast bookings across 3 to 15 ton payload capacity, with scheduled runs and return-leg consolidation between Fujairah and Dubai arranged under a single booking on confirmed lead time.",
    ],
  },
  // Home About
  {
    type: "about",

    title: "Why Businesses Rely on Our Refrigerated Transport Services in Dubai ",

    image: AboutImg4,

    imageAlt: "Insulated freezer van interior showing cold chain reliability in Dubai",

    reverse: false,

    whatsappButton: true,

    paragraphs: [
      "Businesses across Dubai rely on us because our refrigerated transport operations are managed through an active fleet system. From our dispatch base in Ras Al Khor, vehicle allocation, route scheduling, and delivery movement are handled  based on cargo type, delivery timing, and transport conditions across different parts of the city.",

      "During transit, both vehicle location and internal cargo temperature are monitored through GPS and temperature tracking systems. This helps maintain visibility over refrigerated movement throughout loading, delivery, and route progression — especially during time-sensitive cold chain operations.",

      "Over the last 13 years, our fleet has expanded to more than 250 refrigerated vans and trucks supporting daily distribution requirements across Dubai and the UAE. Some operations involve routine supply movement, while others require rapid fleet deployment during higher transport demand periods.",
    ],
  },
  // Home CTA
  {
    type: "home-cta",
    title: "Book Refrigerated Van or Truck for rent in Dubai Now !",
    description:
      "Need refrigerated vehicles on short notice? Chiller Fleet Transport provides chiller vans, freezer vans, and refrigerated trucks for rent across Dubai with fleet availability for both scheduled and same-day deployment. Contact our team today to arrange refrigerated vehicle deployment across Dubai and UAE transport routes.",
  },
];